import React from 'react';

import PreparedFroalaEditor, {
  defaultConfig,
  Props,
} from 'app/components/general/RichTextarea/PreparedFroalaEditor/index';

const removeVideoAndDocLinkButtons = (buttons: Array<string>): Array<string> =>
  buttons.filter(
    (i) => ['insertVideo', 'documentLinkButton'].indexOf(i) === -1
  );

function DemoPreparedFroalaEditor(props: Props): JSX.Element {
  function limitedToolbarButtons() {
    const {toolbarButtons} = defaultConfig('procedureversion');

    if (toolbarButtons == null) {
      return {};
    }

    const formatButtons = toolbarButtons['moreText'].buttons;
    const insertButtons = toolbarButtons['moreRich'].buttons;

    return {
      toolbarButtons: [
        formatButtons,
        removeVideoAndDocLinkButtons(insertButtons),
      ],
    };
  }

  let preparedProps: Props = {
    ...props,
    options: {
      ...(props.options || {}),
      imageUploadToS3: false,
      videoUpload: false,
      ...limitedToolbarButtons(),
    },
  };
  return <PreparedFroalaEditor {...preparedProps} />;
}

export default DemoPreparedFroalaEditor;
